/*
 * @Author: cc
 * @Date: 2020-03-31 16:16:47
 * @LastEditTime: 2021-04-23 17:44:14
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\iWo\iWoPreview\directive\trsPreviewHeight.js
 * @Description: 
 */
'use strict';

angular.module('trsPreviewHeightModule', [])
    .directive('trsPreviewHeight', ['$window', '$timeout', function($window, $timeout) {
        return {
            restrict: 'A',
            link: function(scope, iElement, iAttrs) {
                var fixHeight = !isNaN(iAttrs.fixHeight) ? Number(iAttrs.fixHeight) : 170;
                $('body').css({
                    overflow: 'hidden'
                });

                /**
                 * [setHeight description]
                 * @return  {[type]}  [return description]
                 */
                function setHeight() {
                    iElement.height($(window).height() - fixHeight);
                }
                setHeight();
                $(window).resize(function(event) {
                    setHeight();
                });
                scope.$on('$destroy', function() {
                    $('body').removeAttr('style');
                });
            }
        };
    }]);
